import { render, staticRenderFns } from "./storeOrderReview.vue?vue&type=template&id=29dc764c&scoped=true&"
import script from "./storeOrderReview.vue?vue&type=script&lang=js&"
export * from "./storeOrderReview.vue?vue&type=script&lang=js&"
import style0 from "./storeOrderReview.vue?vue&type=style&index=0&id=29dc764c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc764c",
  null
  
)

export default component.exports